<template>
  <header
    class="desktop-header"
    @mouseleave="onMouseleave"
    @mouseover="isMenuClicked = true"
  >
    <div class="header-container">
      <h2 class="logo">
        <router-link :to="{ name: ROUTE_NAME.Main }"
          ><img src="@assets/img/contents/header_logo.svg" alt=""
        /></router-link>
      </h2>
      <ul class="center-menu-wrapper">
        <li>
          <router-link :to="{ name: ROUTE_NAME.ClubIntroduction }"
            >클럽소개</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: ROUTE_NAME.Guide }">이용안내</router-link>
        </li>
        <li>
          <router-link :to="{ name: ROUTE_NAME.Notice, query: { type: 0 } }"
            >공지&이벤트</router-link
          >
        </li>
        <li>
          <router-link
            :to="{
              name: ROUTE_NAME.Reservation,
              query: {
                type:
                  userStore.membershipList.find(
                    (f) => f.membershipId === commonStore.membershipId
                  )?.memberGrade === 'Y_MEM'
                    ? 0
                    : 1,
              },
            }"
            >예약 및 요금</router-link
          >
        </li>
      </ul>
      <ul class="right-menu-wrapper">
        <li
          v-if="commonStore.isSignIn"
          @click="membershipChangeClick"
          class="membership"
        >
          <b
            ><img src="@assets/img/contents/icon_change02.svg" alt="회원권변경"
          /></b>
          회원권변경
        </li>
        <li v-if="commonStore.isSignIn">
          <router-link
            :to="{ name: ROUTE_NAME.MyPage, query: { type: 0, subType: 1 } }"
          >
            <b
              ><img src="@assets/img/contents/icon_mypage.svg" alt="마이페이지"
            /></b>
            마이페이지
          </router-link>
        </li>
        <li class="reservation">
          <router-link :to="{ name: ROUTE_NAME.Reservation }">
            <b
              ><img
                src="@assets/img/contents/icon_calendar-desktop.svg"
                alt="실시간예약"
            /></b>
            실시간예약
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: ROUTE_NAME.RealCam }">
            <b
              ><img src="@assets/img/contents/icon_video.svg" alt="실시간현장"
            /></b>
            실시간현장
          </router-link>
        </li>
        <!-- 클릭 시 메뉴 오픈 -->
        <li class="open" @click="handleToggleMenu(!isMenuClicked)">
          <span
            ><img src="@assets/img/contents/icon_menu.svg" alt="메뉴"
          /></span>
        </li>
      </ul>
    </div>

    <div class="lnb" :class="isMenuClicked ? 'active' : 'hide'">
      <div class="lnb-top">
        <ul>
          <li v-if="!commonStore.isSignIn" class="signIn">
            <router-link :to="{ name: ROUTE_NAME.Signin }">
              <b></b>
              로그인</router-link
            >
          </li>
          <li class="signUp">
            <router-link :to="{ name: ROUTE_NAME.SignupIntro }">
              <b></b>
              회원가입
            </router-link>
          </li>
          <li v-if="commonStore.isSignIn" class="mypage">
            <router-link
              :to="{ name: ROUTE_NAME.MyPage, query: { type: '0' } }"
            >
              <b></b><a>마이페이지</a>
            </router-link>
          </li>
          <li class="video">
            <router-link :to="{ name: ROUTE_NAME.RealCam }">
              <b> </b>
              실시간현장
            </router-link>
          </li>
          <li
            v-if="commonStore.isSignIn"
            @click="handleSignOut"
            class="signOut"
          >
            <b></b><a>로그아웃</a>
          </li>
        </ul>
        <div class="move-site">
          <a :href="moveSite">
            <img src="@assets/img/icon_move-site-sj.svg" alt="" />
            <span>블루원상주 바로가기</span>
          </a>
        </div>
      </div>
      <div class="lnb-main">
        <div class="lnb-main-item">
          <ul class="lnb01">
            <li><a class="title">클럽소개</a></li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.ClubIntroduction }"
                >클럽소개</router-link
              >
            </li>
            <li
              @mouseenter="menuActive.courseInfo = true"
              @mouseleave="menuActive.courseInfo = false"
            >
              <!-- .lnb01 > .title02에 mouseenter 시 .lnb02 열림 -->
              <!-- .lnb02 메뉴 펼쳐질때 .title02에 addClass .on -->
              <a class="title02" :class="{ on: menuActive.courseInfo }"
                >코스소개</a
              >
              <!-- .lnb02 메뉴 펼쳐질때 toggleClass .open/.close -->
              <ul
                class="lnb02"
                :class="[menuActive.courseInfo ? 'open' : 'close']"
              >
                <li>
                  <router-link
                    :to="{
                      name: ROUTE_NAME.CourseInformation,
                      query: { type: 0 },
                    }"
                    >코스안내</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{
                      name: ROUTE_NAME.CourseInformation,
                      query: { type: 1 },
                    }"
                    >서코스(회원제)</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{
                      name: ROUTE_NAME.CourseInformation,
                      query: { type: 2 },
                    }"
                    >중코스(회원제)</router-link
                  >
                </li>
                <li>
                  <router-link
                    :to="{
                      name: ROUTE_NAME.CourseInformation,
                      query: { type: 3 },
                    }"
                    >동코스(대중형)</router-link
                  >
                </li>
              </ul>
            </li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.Restaurant }"
                >대식당 (F&B)</router-link
              >
            </li>
            <li
              @mouseenter="menuActive.facilities = true"
              @mouseleave="menuActive.facilities = false"
            >
              <!-- .lnb01 > .title02에 mouseenter 시 .lnb02 열림 -->
              <!-- .lnb02 메뉴 펼쳐질때 .title02에 addClass .on -->
              <a class="title02" :class="{ on: menuActive.facilities }"
                >부대시설</a
              >
              <!-- .lnb02 메뉴 펼쳐질때 toggleClass .open/.close -->
              <ul
                class="lnb02"
                :class="[menuActive.facilities ? 'open' : 'close']"
              >
                <li>
                  <router-link :to="{ name: ROUTE_NAME.Lobby }"
                    >클럽하우스 (프로샵)</router-link
                  >
                </li>
                <!--                <li>
                  <router-link :to="{ name: ROUTE_NAME.Restaurant }"
                    >대식당</router-link
                  >
                </li>-->
                <li>
                  <router-link :to="{ name: ROUTE_NAME.HalfwayHouse }"
                    >스타트하우스</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: ROUTE_NAME.BanquetHall }"
                    >연회실</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: ROUTE_NAME.LockerRoom }"
                    >락카&사우나</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: ROUTE_NAME.GasStation }"
                    >주유소&편의점</router-link
                  >
                </li>
              </ul>
            </li>
            <li>
              <a>
                <router-link
                  :to="{ name: ROUTE_NAME.ClubIntroduction, hash: '#location' }"
                  >오시는길</router-link
                ></a
              >
            </li>
          </ul>
          <ul class="lnb01">
            <li><a class="title">이용안내</a></li>
            <li
              @mouseenter="menuActive.useMembership = true"
              @mouseleave="menuActive.useMembership = false"
            >
              <a class="title02" :class="{ on: menuActive.useMembership }"
                >회원제 이용안내</a
              >
              <ul
                class="lnb02"
                :class="[menuActive.useMembership ? 'open' : 'close']"
              >
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 0, subType: 0 },
                      }"
                      >이용방법</router-link
                    >
                  </a>
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 0, subType: 1 },
                      }"
                      >예약안내</router-link
                    >
                  </a>
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 0, subType: 2 },
                      }"
                      >위약규정</router-link
                    >
                  </a>
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 0, subType: 3 },
                      }"
                      >회원특전</router-link
                    >
                  </a>
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 0, subType: 4 },
                      }"
                      >회원권안내</router-link
                    ></a
                  >
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 0, subType: 5 },
                      }"
                      >캐디선택 Tip</router-link
                    ></a
                  >
                </li>
              </ul>
            </li>
            <li
              @mouseenter="menuActive.usePublic = true"
              @mouseleave="menuActive.usePublic = false"
            >
              <a class="title02" :class="{ on: menuActive.usePublic }"
                >대중형 이용안내</a
              >
              <ul
                class="lnb02"
                :class="[menuActive.usePublic ? 'open' : 'close']"
              >
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 1, subType: 0 },
                      }"
                      >이용방법</router-link
                    ></a
                  >
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 1, subType: 1 },
                      }"
                      >예약안내</router-link
                    ></a
                  >
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 1, subType: 2 },
                      }"
                      >위약규정</router-link
                    ></a
                  >
                </li>
                <li>
                  <a>
                    <router-link
                      :to="{
                        name: ROUTE_NAME.Guide,
                        query: { type: 1, subType: 3 },
                      }"
                      >이용약관</router-link
                    ></a
                  >
                </li>
              </ul>
            </li>
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Guide,
                    query: { type: 2, subType: 0 },
                  }"
                  >로컬룰</router-link
                ></a
              >
            </li>
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Guide,
                    query: { type: 3, subType: 0 },
                  }"
                  >단체문의</router-link
                ></a
              >
            </li>
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Guide,
                    query: { type: 4, subType: 0 },
                  }"
                  >이용약관</router-link
                ></a
              >
            </li>
          </ul>
          <ul class="lnb01">
            <li><a class="title">공지/이벤트</a></li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.Notice, query: { type: 0 } }"
                >공지사항</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.Notice, query: { type: 1 } }"
                >이벤트</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.Notice, query: { type: 2 } }"
                >명예의전당</router-link
              >
            </li>
          </ul>
          <ul class="lnb01">
            <li><a class="title">예약 및 요금</a></li>
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Reservation,
                    query: { type: 0 },
                  }"
                >
                  회원제예약
                </router-link>
              </a>
            </li>
            <li>
              <a
                ><router-link
                  :to="{
                    name: ROUTE_NAME.Reservation,
                    query: { type: 1 },
                  }"
                >
                  대중형예약
                </router-link></a
              >
            </li>
            <li>
              <a
                ><router-link
                  :to="{
                    name: ROUTE_NAME.Reservation,
                    query: { type: 2 },
                  }"
                >
                  예약확인 및 취소
                </router-link></a
              >
            </li>
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Reservation,
                    query: { type: 3, subType: 0 },
                  }"
                >
                  회원 요금제
                </router-link></a
              >
            </li>
            <!-- <li
              @mouseenter="menuActive.membershipPrice = true"
              @mouseleave="menuActive.membershipPrice = false"
            >
              <a class="title02" :class="{ on: menuActive.membershipPrice }"
                >회원 요금제</a
              >
              <ul
                class="lnb02"
                :class="[menuActive.membershipPrice ? 'open' : 'close']"
              >
                <li>
                  <a
                    ><router-link
                      :to="{
                        name: ROUTE_NAME.Reservation,
                        query: { type: 3, subType: 0 },
                      }"
                    >
                      요금안내
                    </router-link></a
                  >
                </li>
                <li>
                  <a
                    ><router-link
                      :to="{
                        name: ROUTE_NAME.Reservation,
                        query: { type: 3, subType: 1 },
                      }"
                    >
                      위약규정
                    </router-link></a
                  >
                </li>
              </ul>
            </li> -->
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Reservation,
                    query: { type: 4, subType: 0 },
                  }"
                >
                  대중형 요금제
                </router-link></a
              >
            </li>
            <li>
              <a>
                <router-link
                  :to="{
                    name: ROUTE_NAME.Reservation,
                    query: { type: 5, subType: 0 },
                  }"
                >
                  상시 우대할인
                </router-link></a
              >
            </li>
          </ul>
          <ul class="lnb01">
            <li><a class="title">마이페이지</a></li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.MyPage, query: { type: 0 } }"
                >정보수정</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.MyPage, query: { type: 1 } }"
                >회원탈퇴</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: ROUTE_NAME.MyPage, query: { type: 2 } }"
                >대중형 모바일 이용권</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="btn-menu-close" @click="isMenuClicked = false">
        <span
          ><img src="@assets/img/contents/icon_menu-close.svg" alt=""
        /></span>
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
/*import { ref, watch, computed } from 'vue';
import { MWeatherInfo } from '@molecules';
import { useCommonStore, useUserStore } from '@stores';
import { useSignOut, useScroll, useIsMain } from '@composables';
import { useRouter } from 'vue-router';
import { ROUTE_NAME } from '@constants';

const commonStore = useCommonStore();
const userStore = useUserStore();
const isAdmin = computed(() => userStore.grant === 'WEB_ADMIN');
const { handleSignOut: signOut } = useSignOut();
const { isScroll } = useScroll();
const { isMain } = useIsMain();
const { currentRoute, push } = useRouter();
const isMenuClicked = ref<boolean>(false);

const handleToggleMenu = (value: boolean) => {
  isMenuClicked.value = value;
};
const handleSignin = () => {
  commonStore.setSigninOpen(true);
};

const handleSignOut = async () => {
  await signOut();
  await push({ name: ROUTE_NAME.Main });
};

watch(currentRoute, () => {
  handleToggleMenu(false);
}); */
import { useSignOut } from '@composables';
import { ROUTE_NAME } from '@constants';
import { useCommonStore, useUserStore } from '@stores';
import { reactive, ref, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
const isMenuClicked = ref<boolean>(false);
const { handleSignOut: signOut } = useSignOut();
const commonStore = useCommonStore();
const userStore = useUserStore();
const { push, currentRoute } = useRouter();

const moveSite = computed(() => {
  const url =
    import.meta.env.VITE_APP_NODE_ENV !== 'production'
      ? 'https://blueonesj-dev.greenit.cc'
      : 'https://sj.blueone.com';
  return url;
});

const menuActive = reactive({
  courseInfo: false,
  facilities: false,
  useMembership: false,
  usePublic: false,
  membershipPrice: false,
  publicPrice: false,
});
const membershipChangeClick = () => {
  const currentPath = currentRoute.value.fullPath;
  localStorage.setItem('redirect', currentPath);
  commonStore.setMembershipChange(true);
};
const onMouseleave = () => {
  if (isMenuClicked.value) {
    isMenuClicked.value = false;
  }
};
const handleToggleMenu = (value: boolean) => {
  isMenuClicked.value = value;
};
const handleSignOut = async () => {
  await signOut();
  await push({ name: ROUTE_NAME.Main });
};

watch(currentRoute, () => {
  handleToggleMenu(false);
});
</script>

<style scoped lang="scss">
.desktop-header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: var(--main-color);
  /*  background-image: linear-gradient(
    to right,
    rgba(34, 211, 253, 1),
    rgba(0, 61, 91, 1)
  );*/
  height: 72px;

  .header-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 35px 0 56px;
    position: relative;

    h2.logo {
      /*width: 10%;*/
      cursor: pointer;
      img {
        width: 157px;
        height: 40px;
      }
    }
  }

  .center-menu-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 50px;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    li {
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
    }
    a {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .right-menu-wrapper {
    display: flex;
    align-items: center;
    gap: 0 15px;

    height: 100%;
    li {
      font-size: 16px;
      color: #fff;
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    a {
      display: flex;
      align-items: center;
      gap: 0 8px;
      width: 100%;
      height: 100%;
    }
    b {
      display: inline-block;
      width: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    li.reservation {
      b {
        width: 28px;
      }
    }
    li.membership {
      gap: 0 8px;
    }
  }
}

/* Menu */
.desktop-header .lnb {
  width: 100%;
  background: #f9f9f9;
  position: relative;
  padding-bottom: 100px;
  display: none;

  /* Menu-list01 */
  .lnb-top {
    width: 100%;
    height: 145px;
    position: relative;

    /*    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 50px;*/

    ul {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 45px;
    }
    li {
      font-size: 13px;
      color: #666;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      gap: 10px 0;
      z-index: 10;
    }
    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px 0;
    }
    b {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 41px;
      height: 41px;
      position: relative;
    }
    li.signIn b {
      background: url('@assets/img/contents/icon_header-login.svg') no-repeat
        center center #74c5b9;
      border: 1px solid #74c5b9;
    }
    li.signUp b {
      background: url('@assets/img/contents/icon_header-signup.svg') no-repeat
        center center #74c5b9;
      border: 1px solid #74c5b9;
    }
    li.mypage b {
      background: url('@assets/img/contents/icon_header-mypage.svg') no-repeat
        center center var(--main-color);
      border: 1px solid var(--main-color);
    }
    li.video b {
      background: url('@assets/img/contents/icon_header-video.svg') no-repeat
        center center #fff;
      border: 1px solid #bfbfbf;
    }
    li.signOut b {
      background: url('@assets/img/contents/icon_header-logout.svg') no-repeat
        center center var(--main-color);
      border: 1px solid var(--main-color);
    }
    li:nth-of-type(4) {
      margin-right: 70px;
    }
    .move-site {
      position: absolute;
      right: 50px;
      top: 50%;
      transform: translateY(-50%);
      min-width: 250px;
      background: #fff;
      a {
        border: 1px solid #0dbbac;
        border-radius: 10px;
        padding: 20px;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        gap: 0 20px;
        width: 100%;
        span {
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }

  /* Menu-list02 */
  .lnb-main {
    background: #fff;
    min-height: 330px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    z-index: 0;
    padding: 50px 0;

    .lnb-main-item {
      display: flex;
      justify-content: center;
      gap: 0 30px;
    }
    ul {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px 0;
      min-width: 160px;
    }
    ul li {
      font-size: 16px;
      color: #707070;
      position: relative;
      cursor: pointer;
      text-align: center;
    }
    ul li a.title {
      font-size: 16px;
      color: #000;
      cursor: default;
    }
    ul li a:not(.title, .title02):hover {
      color: var(--main-color);
      transition: 0.3s ease;
    }
    ul li a:not(.title, .title02)::after {
      content: '';
      width: 0%;
      height: 1px;
      background: var(--main-color);
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
      transition: 0.3s ease;
    }
    ul li a:not(.title, .title02):hover::after {
      width: 100%;
    }
    a {
      text-align: center;
      position: relative;
    }
    ul.lnb02 {
      gap: 15px 0;
      margin-top: 15px;
      /*display: none;*/
    }
    ul.lnb02.close {
      display: none;
    }
    ul.lnb02.open {
      display: flex;
      animation: open 0.6s ease;
    }
    ul.lnb02.open li {
      color: var(--main-color);
    }
    ul.lnb02.close {
      animation: close 0.6s ease;
    }
    ul.lnb01 li a.title02.on {
      color: var(--main-color);
    }
    ul.lnb01 li a.title02.on::after {
      content: '';
      width: 100%;
      height: 1px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: var(--main-color);
    }
  }

  /* Menu 닫기버튼 */
  .btn-menu-close {
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 60px;
    cursor: pointer;
  }
}

/* 메뉴 모션 */
.desktop-header .lnb.active {
  animation: showLnb 0.3s ease;
  display: block;
}

.desktop-header .lnb.hide {
  animation: hideLnb 0.3s ease;
  display: none;
}

@keyframes showLnb {
  0% {
    opacity: 0;
    transform: translateY(-150px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes hideLnb {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-150px);
  }
}

@keyframes open {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes close {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
